import { Link } from 'react-router-dom';
import { brands } from '@/mocks/products';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { useState } from 'react';

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <section className="w-full relative h-[350px] md:h-[420px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cream%20minimalist%20abstract%20background%20with%20elegant%20soft%20flowing%20curves%20and%20textured%20layers%2C%20light%20beige%20and%20cream%20tones%2C%20subtle%20gradient%2C%20artistic%20composition%2C%20calm%20and%20trustworthy%20atmosphere%2C%20no%20text&width=1600&height=800&seq=about-hero-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4">
              关于精品国产
            </h1>
            <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
              汇聚中国匠心制造的高品质国货精品，为消费者甄选值得信赖的国产好物
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    精品国产成立于2023年，是一家专注于国货精品推荐与深度评测的内容平台。
                    我们的团队由一群热爱中国制造、相信中国品质的资深编辑和行业专家组成，
                    致力于为消费者提供专业、客观、真实的国货选购指南。
                  </p>
                  <p>
                    在过去几年中，中国品牌在产品设计、技术研发和品质管控上取得了令人瞩目的进步。
                    从华为的5G技术到大疆的无人机，从安踏的运动科技到花西子的东方美学，
                    越来越多的国货品牌正在用实力赢得消费者的信赖。然而，面对海量的国货产品，
                    消费者往往难以做出明智的选择——这正是精品国产存在的意义。
                  </p>
                  <p>
                    我们坚持<strong>严选标准</strong>，每一款推荐的产品都经过团队的实际体验和多维度评测。
                    我们不盲目追求低价，而是聚焦于<strong>品质、设计、体验和性价比</strong>的平衡，
                    帮助用户找到真正值得购买的国产好物。
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[320px] shrink-0">
                <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-4">我们的理念</h3>
                  <ul className="space-y-3">
                    {[
                      { icon: 'ri-shield-check-line', text: '品质优先，严选推荐' },
                      { icon: 'ri-eye-line', text: '客观评测，真实反馈' },
                      { icon: 'ri-heart-line', text: '支持国货，匠心精选' },
                      { icon: 'ri-user-smile-line', text: '用户至上，真诚服务' },
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                          <i className={item.icon}></i>
                        </div>
                        <span className="text-sm text-foreground-700">{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4 text-center">
              合作品牌
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
              与优秀的国货品牌携手，构建值得信赖的推荐体系
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {brands.map((brand) => (
                <div
                  key={brand.name}
                  className="flex flex-col items-center p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="w-16 h-16 rounded-full overflow-hidden mb-3 bg-background-100">
                    <img
                      src={brand.logo}
                      alt={`${brand.name} 品牌`}
                      title={`${brand.name} - ${brand.description}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-sm font-semibold text-foreground-800 mb-1">
                    {brand.name}
                  </span>
                  <span className="text-xs text-foreground-500 text-center leading-tight">
                    {brand.productCount.toLocaleString()}+ 好物
                  </span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4 text-center">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
              来自真实用户的评价与反馈
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  name: '李女士',
                  role: '资深宝妈',
                  comment: '在精品国产上种草了很多好东西，尤其是国产护肤品推荐特别靠谱，性价比远超我之前用的国际大牌。现在全家都用国货！',
                  rating: 5,
                },
                {
                  name: '张先生',
                  role: '科技爱好者',
                  comment: '作为一个数码控，精品国产的科技产品评测非常专业。推荐的几款国产手机和耳机都很满意，国产科技真的越来越强了。',
                  rating: 5,
                },
                {
                  name: '王同学',
                  role: '大学生',
                  comment: '预算有限但又想买好东西，精品国产帮我避开了很多坑。推荐的百元级国货好物，学生党也能轻松入手。',
                  rating: 5,
                },
              ].map((review, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-sm font-semibold text-primary-600">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{review.name}</div>
                      <div className="text-xs text-foreground-500">{review.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4 text-center">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-md mx-auto">
              关于精品国产的常见疑问
            </p>
            <div className="space-y-4">
              {[
                {
                  q: '精品国产是如何筛选推荐产品的？',
                  a: '我们的编辑团队会从品牌实力、产品品质、用户口碑、性价比等多个维度进行综合评估。每一款推荐产品都经过实际体验和多轮评测，确保推荐的专业性和客观性。',
                },
                {
                  q: '推荐的产品可以直接购买吗？',
                  a: '精品国产是一个内容推荐平台，我们提供产品评测和选购建议。用户可以通过我们提供的信息跳转到各品牌的官方渠道或电商平台进行购买。',
                },
                {
                  q: '如何成为精品国产的合作品牌？',
                  a: '欢迎优质国货品牌与我们合作。请通过联系我们页面的表单提交合作意向，我们的商务团队会在3-5个工作日内与您取得联系。',
                },
                {
                  q: '网站内容多久更新一次？',
                  a: '我们保持每周至少更新2-3篇深度评测或推荐文章，确保内容的时效性和丰富度。关注我们的公众号可以第一时间获取更新通知。',
                },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70 cursor-pointer">
                  <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-lg transition-transform group-open:rotate-180"></i>
                  </summary>
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-md mx-auto">
              有任何问题或合作意向，欢迎通过以下方式与我们取得联系
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '电子邮箱',
                  value: 'contact@jingpinguohuo.com',
                },
                {
                  icon: 'ri-wechat-line',
                  title: '微信公众号',
                  value: '精品国产',
                },
                {
                  icon: 'ri-map-pin-line',
                  title: '公司地址',
                  value: '北京市朝阳区建国路88号',
                },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-600">{item.value}</p>
                </div>
              ))}
            </div>

            <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-6 text-center">
                发送消息
              </h3>
              <ContactForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '精品国产是如何筛选推荐产品的？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的编辑团队会从品牌实力、产品品质、用户口碑、性价比等多个维度进行综合评估。每一款推荐产品都经过实际体验和多轮评测，确保推荐的专业性和客观性。',
                },
              },
              {
                '@type': 'Question',
                name: '推荐的产品可以直接购买吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '精品国产是一个内容推荐平台，我们提供产品评测和选购建议。用户可以通过我们提供的信息跳转到各品牌的官方渠道或电商平台进行购买。',
                },
              },
              {
                '@type': 'Question',
                name: '如何成为精品国产的合作品牌？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '欢迎优质国货品牌与我们合作。请通过联系我们页面的表单提交合作意向，我们的商务团队会在3-5个工作日内与您取得联系。',
                },
              },
              {
                '@type': 'Question',
                name: '网站内容多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们保持每周至少更新2-3篇深度评测或推荐文章，确保内容的时效性和丰富度。关注我们的公众号可以第一时间获取更新通知。',
                },
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '关于精品国产 - 品牌介绍',
            description: '精品国产品牌介绍、用户口碑、联系方式。汇聚中国匠心制造的高品质国货精选推荐平台。',
            url: 'https://jingpinguohuo.com/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://jingpinguohuo.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                  item: 'https://jingpinguohuo.com/about',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}

function ContactForm() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      setFormError('');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 4000);
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rcpdee3oq4jqumtvk0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setFormStatus('error');
        setFormError(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <form
      id="contact-form"
      data-readdy-form
      className="space-y-5"
      onSubmit={(e) => handleSubmit(e)}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
            姓名
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
            邮箱
          </label>
          <input
            type="email"
            id="contact-email"
            name="email"
            required
            className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>
      <div>
        <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
          主题
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          required
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
          placeholder="请输入消息主题"
        />
      </div>
      <div>
        <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
          消息内容
        </label>
        <textarea
          id="message"
          name="message"
          required
          rows={5}
          maxLength={500}
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
          placeholder="请输入您的消息（最多500字）"
        ></textarea>
        <p className="text-xs text-foreground-500 mt-1">最多500字符</p>
      </div>

      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="website-alt-field"
      />

      <div className="text-center">
        <button
          type="submit"
          disabled={formStatus === 'submitting'}
          className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all whitespace-nowrap cursor-pointer"
        >
          {formStatus === 'submitting' ? '发送中...' : '发送消息'}
        </button>
        {formStatus === 'success' && (
          <p className="mt-3 text-sm text-green-600">消息发送成功！我们会尽快回复您。</p>
        )}
        {formStatus === 'error' && (
          <p className="mt-3 text-sm text-red-500">{formError}</p>
        )}
      </div>
    </form>
  );
}